import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '../../store';
import type { IServiceCode } from '../../utils/types';

// Loaded service codes labelled `${label} (${code})` for autocomplete/select
// dropdowns. Wraps the Redux read so component files stay free of `useSelector`.
// `filterCodes`, when provided, restricts and orders the list by those raw codes.
export const useServiceCodeOptions = (
  filterCodes?: readonly string[],
  labelsByCode?: Partial<Record<string, string>>,
): IServiceCode[] => {
  const serviceCodes = useSelector((state: RootState) => state.serviceCodes.list);

  return useMemo(
    () => {
      const filteredServiceCodes = filterCodes
        ? filterCodes
            .map((code) => serviceCodes?.find((serviceCode) => serviceCode.code === code))
            .filter((serviceCode): serviceCode is IServiceCode => Boolean(serviceCode))
        : serviceCodes ?? [];

      return filteredServiceCodes.map((serviceCode: IServiceCode) => ({
        ...serviceCode,
        label: `${labelsByCode?.[serviceCode.code] ?? serviceCode.label} (${serviceCode.code})`,
      }));
    },
    [serviceCodes, filterCodes, labelsByCode],
  );
};
